// extracted by mini-css-extract-plugin
module.exports = {"operationContent":"operation-content___1U_w-","collapse":"collapse___2z5UJ","notOperations":"not-operations___3jNHr"};